import axiosClient from "../api/axiosClient";
import qs from "qs";

export interface VehiclePayload {
  owner_id: string | number;
  vehicle_type: string;
  manufacturer: string;
  model: string;
  variant?: string | null;
  year_of_manufacture?: string | number | null;
  registration_number: string;
  chassis_number: string;
  engine_number: string;
  fuel_type?: string | null;
  vehicle_color?: string | null;
  seating_capacity?: number | null;
  purchase_date?: string | null; // YYYY-MM-DD
  insurance_expiry?: string | null; // YYYY-MM-DD
  hypothecated_to?: string | null;
  current_status?: string | null;
}

/** Standardized paginated response */
export interface PaginatedResult<T> {
  data: T[];
  current_page: number;
  per_page: number;
  total: number;
  from: number;
  to: number;
  last_page: number;
}



export const getVehicles = async (
  params: any
): Promise<PaginatedResult<any>> => {
  // Use /vehicles/search endpoint when query is provided, otherwise use /vehicles
  const endpoint = params.query ? "/vehicles/search" : "/vehicles";
  const res = await axiosClient.get(endpoint, { params });
  return res.data;
};

export async function getVehicle(id: string | number) {
  const res = await axiosClient.get(`/vehicles/${id}`);
  return res.data;
}

export async function createVehicle(payload: FormData) {
  const res = await axiosClient.post("/vehicles", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export const updateVehicle = async (
  id: string | number,
  payload: FormData
) => {
  // Laravel-friendly method override
  payload.append("_method", "PUT");

  const res = await axiosClient.post(`/vehicles/${id}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};


export async function deleteVehicle(id: string | number) {
  const res = await axiosClient.delete(`/vehicles/${id}`);
  return res.data;
}

export async function getOwners(q?: string) {
  const res = await axiosClient.get("/profiles", { params: { q } });
  return res.data;
}



export function extractApiErrors(error: any): Record<string, string[]> {
  if (error?.response?.data?.errors) {
    return error.response.data.errors as Record<string, string[]>;
  }
  const msg = error?.response?.data?.message || error?.message || "Something went wrong";
  return { _global: [msg] };
}
